import React from 'react';

import {
  Logs,
  Log,
  LogText,
  LogChangedValue,
  LogChanges,
} from '@gogame/components';

import Status from 'scenes/BusinessPartners/components/Status';

const ActionsLog = ({ data }) => {
  return (
    <Logs empty={!data.length}>
      {data.map((log, index) => {
        return (
          <Log key={index}>
            <LogText
              action={log.type}
              user={log.changedBy}
              date={log.createdDate}
            >
              {log.details?.map((change) => {
                switch (change.field) {
                  case 'Status':
                    return (
                      <LogChanges
                        label={change.field}
                        type={'change'}
                        inChip={false}
                      >
                        <LogChangedValue
                          value={<Status id={change.oldValue} />}
                          newValue={<Status id={change.newValue} />}
                        />
                      </LogChanges>
                    );
                  default:
                    return (
                      <LogChanges
                        label={change.field}
                        type={'change'}
                        inChip={true}
                      >
                        <LogChangedValue
                          value={change.oldValue}
                          newValue={change.newValue}
                        />
                      </LogChanges>
                    );
                }
              })}
            </LogText>
          </Log>
        );
      })}
    </Logs>
  );
};

export default ActionsLog;
